import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { FormHelper, ShowErrorsOn, TForm } from './form-helper';

@Injectable({ providedIn: 'root' })
export class FormHelperFactory {
  constructor(private translateService: TranslateService) {}

  create<T extends TForm<T>>(form: FormGroup<T>, showErrorsOn: ShowErrorsOn = 'submit') {
    return new FormHelper(this.translateService, form, showErrorsOn);
  }
}
